import React from 'react';
import { SpinnerSize, Stack, Spinner, useTheme } from '@fluentui/react';

export const SpinnerLoader = (): JSX.Element => {
  const theme = useTheme();
  return (
    <Stack>
      <Spinner
        size={SpinnerSize.large}
        styles={{
          circle: {
            borderColor: `${theme.palette.themePrimary} ${theme.palette.neutralLighter} ${theme.palette.neutralLighter}`,
          },
        }}
      />
    </Stack>
  );
};
